export class IdNameModel {
    id: string | number = 0
    name: string = ''
}